module.exports = __webpack_public_path__ + "static/img/icon-people.d4013074.png";